import { LockablePropertyStripLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import { lockAndMoreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { DropZone } from './DropZone';
import { DropZoneModeWidget } from './DropZoneModeWidget';
import { DropZoneSettingsWidget, DropZoneSettingsWidgetValue } from './DropZoneSettingsWidget';

export const dropZonePropertyLayout = LockablePropertyStripLayout<DropZone>((d, s, o, w, a) => [
    w.createColorSelector({
        allowNull: true,
        autoSelect: true,
        groups: true,
        text: 'Background',
        value: a.get('background'),
        onSelect() {
            o.update(u => {
                u.rolling(a.keyFor('background'));
                a.set('background', this.value!);
            });
        }
    }),
    w.createPopout({
        text: 'Mode',
        image: 'deqo://icons/hero/switch-horizontal',
        ui: DropZoneModeWidget,
        value: a.get('mode'),
        onSelect() {
            o.update(u => {
                u.rolling(a.keyFor('mode'));
                a.set('mode', this.value!);
            });
        }
    }),
    w.createPopout({
        text: 'Settings',
        image: 'deqo://icons/deqo/cog',
        ui: DropZoneSettingsWidget,
        value: DropZoneSettingsWidgetValue(a),
        onSelect() {
            o.update(u => {
                const keys = Object.keys(this.value) as any[];
                u.rolling(a.keyFor(...keys));
                for (const k of keys) {
                    a.set(k, this.value[k]);
                }
            });
        }
    }),
    ...lockAndMoreLayout(d, s, o, w, a),
]);
